import React from 'react';
import { inject, observer } from 'mobx-react';

import Section from '../../../Section/Section';
import Form from '../../../Settings/Form/Form';
import {
  Field, renderSelect,
} from '../../../../utils/formFieldHelper';
import { editorSupportedLanguages } from '../../../../utils/constants';
import { StoresEnum } from '../../../../stores';

const ChannelDefaultLanguage = ({ channelStore: { channel, readOnly, updateChannel } }) => {
  const renderFields = () => (
    <Field
      name="editorLanguage"
      label="Select a default language for the Editor’s UI"
      component={renderSelect(editorSupportedLanguages)}
      readOnly={readOnly}
    />
  );

  const onSubmit = data => updateChannel({
    channelDefaults: { ...(channel.channelDefaults || {}), editorLanguage: data.editorLanguage },
  });

  return (
    <Section title="DEFAULT LANGUAGE">
      <Form
        initialValues={{ editorLanguage: (channel.channelDefaults && channel.channelDefaults.editorLanguage) || 'en' }}
        fields={renderFields()}
        onSubmit={onSubmit}
        hideCancelButton
        hideApproveButton={readOnly}
        approveLabel="Apply"
        approveClass="outlined-secondary"
      />
    </Section>
  );
};

export default inject(StoresEnum.CHANNEL)(observer(ChannelDefaultLanguage));
